/** @jsx h */
import { h } from 'preact'
import ClaimCapsule from '../Capsule'

const Card = props => {
  const { theme, statement, modalUrl } = props

  return (
    <div class='Card'>
      <div class='Card-header'>
        <ClaimCapsule {...props} />
      </div>
      <div class='Card-main'>
        <p class='Card-statement'>“{statement}”</p>
        <a class={`Card-action Card-action--${theme}`} href={modalUrl}>
          See how
        </a>
      </div>
    </div>
  )
}

export default Card
